import { render, staticRenderFns } from "./TrainingScorm.vue?vue&type=template&id=efcdd5ac&"
import script from "./TrainingScorm.vue?vue&type=script&lang=js&"
export * from "./TrainingScorm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports